import type { CSSProperties } from 'react'
import './Curtain.css'

/**
 * Full-screen two-slab wipe, ported from Vollgas' shared `Curtain`.
 * The parent drives `phase` and swaps state while it is `covered`, so
 * any reflow happens behind opaque pixels.
 *
 *   idle       — slabs parked off-screen left
 *   covering   — slabs slide in; the lead finishes first, leaving a
 *                gradient ribbon at the wipe's edge
 *   covered    — slabs at 0%, transitions cancelled; swap now
 *   uncovering — both slabs exit right in lockstep
 */
export type CurtainPhase = 'idle' | 'covering' | 'covered' | 'uncovering'

export const CURTAIN_SLIDE_MS = 250
export const CURTAIN_STAGGER_MS = 70
export const CURTAIN_COVER_MS = CURTAIN_SLIDE_MS + CURTAIN_STAGGER_MS
export const CURTAIN_UNCOVER_MS = CURTAIN_SLIDE_MS

export default function Curtain({ phase }: { phase: CurtainPhase }) {
  const style = {
    '--curtain-slide': `${CURTAIN_SLIDE_MS}ms`,
    '--curtain-stagger': `${CURTAIN_STAGGER_MS}ms`,
  } as CSSProperties

  return (
    <div className="curtain" data-phase={phase} aria-hidden="true" style={style}>
      <div className="curtain__slab curtain__slab--lead" />
      <div className="curtain__slab curtain__slab--trail" />
    </div>
  )
}
